module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "layout"
  }, [(_vm.$auth.check()) ? _c('div', [(_vm.$store.state.config.loaded) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('config-bar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('foo')], 1)]) : _c('loader')], 1) : _c('login')], 1) : _c('loader')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e6fb320", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6fb320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/layout.vue
// module id = 793
// module chunks = 0